import type { StackProps } from '@mui/material';
import { Stack } from '@mui/material';

/**
 * 가로 전용 Stack.
 */
export const HStack = (props: Omit<StackProps, 'direction'>) => {
  return <Stack {...props} direction={'row'} />;
};

/**
 * 세로 전용 Stack
 */
export const VStack = (props: Omit<StackProps, 'direction'>) => {
  return <Stack {...props} direction={'column'} />;
};
